import { render, staticRenderFns } from "./font.vue?vue&type=template&id=68a79ff2"
import script from "./font.vue?vue&type=script&lang=js"
export * from "./font.vue?vue&type=script&lang=js"
import style0 from "./font.vue?vue&type=style&index=0&id=68a79ff2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports